import fullLogo from './image/full-log.png';
import logo from './image/logo.png';

// banner 
import banner from './Facebook-Cover.jpg';

// service
import service1 from './image/service/1.jpg';
import service2 from './image/service/2.jpg';
import service3 from './image/service/3.jpg';
import service4 from './image/service/4.jpg';
import service5 from './image/service/5.jpg';
import service6 from './image/service/6.jpg';

// tools
import tl1 from './image/tools/ex.jpg';
import tl2 from './image/tools/ex1.jpg';
import tl3 from './image/tools/ex2.jpg';
import tl4 from './image/tools/ex3.jpg';
import tl5 from './image/tools/ex4.jpg';
import tl6 from './image/tools/ex5.jpg';
import tl7 from './image/tools/ex6.jpg';
import tl8 from './image/tools/ex7.jpg';

// about
import about1 from './image/about.jpg';


// animation
import email_marketing from './svg/Email Marketing 2.json';
import mental_therapy from './svg/MentalTherapy.json';
import video_player from './svg/YouTube Logo.json';


// doctor
import doctor_1 from './doctor/Sufian.png';

export const Images = {
  logo,
  fullLogo,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  tl1,
  tl2,
  tl3,
  tl4,
  tl5,
  tl6,
  tl7,
  tl8,
  about1,
  email_marketing,
  mental_therapy,
  doctor_1,
  video_player,
  banner
};
